import { render } from "./DashboardBlockWizard.vue?vue&type=template&id=392331bc&scoped=true"
import script from "./DashboardBlockWizard.vue?vue&type=script&lang=js"
export * from "./DashboardBlockWizard.vue?vue&type=script&lang=js"

import "./DashboardBlockWizard.vue?vue&type=style&index=0&id=392331bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392331bc"]])

export default __exports__